import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import {
    DropzoneContainer,
    DropzoneText,
    PreviewContainer,
} from './DragAndDrop.styles';
// import { uploadAndStage } from '../../api/api'; // ✅ correct import

export default function DragAndDrop({ onFileUpload, disabled = false }) {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const onDrop = useCallback((acceptedFiles) => {
        if (disabled) return;
        setFiles(acceptedFiles);          // keep local preview only
            onFileUpload?.(acceptedFiles);    // pass File[] to parent
        }, [onFileUpload, disabled]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        multiple: false,
        disabled,
        accept: {
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
            'application/vnd.ms-excel': ['.xls'],
            'text/csv': ['.csv']
        }
    });

    return (
        <>
            <DropzoneContainer {...getRootProps()} isdragactive={isDragActive.toString()} disabled={disabled}>
                <input {...getInputProps()} />
                <DropzoneText>
                    {disabled ? 'Please select a vendor first' :
                        loading ? 'Uploading...' :
                        isDragActive ? 'Drop the file here...' :
                        'Drag and drop Excel or CSV file here'}
                </DropzoneText>
            </DropzoneContainer>

            {error && (
                <div style={{ color: 'red', marginTop: '10px' }}>
                    {error}
                </div>
            )}

            <PreviewContainer>
                {files.map(file => (
                    <div key={file.name}>
                        {file.name} - Upload complete
                    </div>
                ))}
            </PreviewContainer>
        </>
    );
}
